module.exports = __webpack_public_path__ + "img/three_icon.f5fae556.png";